export abstract class ShapeCommand implements Command {
  // protected abstract firstAction: boolean;
  protected abstract services;
  protected object;

  constructor(data) {
    this.object = data;
  }

  public injectServices(services): this {
    if (this.services) {
      return;
    } else {
      this.services = {};
    }

    Object.assign(this.services, services);

    return this;
  }

  // abstract execute(): any;

  public execute(): Promise<any> | any {
    if (!this.services || !this.object) {
      return;
    }
  }

  public reverse(): Promise<any> | any {
    if (!this.services || !this.object) {
      return;
    }
  }
}

export abstract class TypedShapeCommand<T> extends ShapeCommand {
  protected object: T;

  constructor(data: T) {
    super(data);
  }
}

export interface Command {
  execute(): Promise<any> | any;

  reverse(): Promise<any> | any;
}
